export default __webpack_public_path__ + "static/media/3536 spice rack E top.0479dfe8.png";